enum notificationActionTypes {
    SHOW_NOTIFICATION = 'SHOW_NOTIFICATION',
    CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION',
}

export default notificationActionTypes;
